import { useCallback } from 'react'
import { useContextSelector } from 'use-context-selector'

const EMPTY = []

const sameId = (a, b) => String(a) === String(b)

// Hotels excluded from the compset in an analyzer (Competition / Packages): they stay in the tables, struck-through,
// but the backend leaves them out of every compset figure (`excludedHotelID`). The list lives in the dashboard's
// submitted filters, so a toggle re-runs the requests at once; the dashboard's useFilters mirrors it into the
// common filters (header hotel selector + "Filter" button + Excel).
// `cachedQuery` = the value the dashboard's pin uses to re-run its requests (Competition true, Packages false).
export default function useCompsetExclusion(SubmittedFiltersContext, { cachedQuery }) {
    const excludedIds = useContextSelector(SubmittedFiltersContext, ({ state }) => state.excludedHotelID) || EMPTY
    const updateSubmittedFilters = useContextSelector(SubmittedFiltersContext, ({ updateState }) => updateState)

    const isExcluded = useCallback(idHotel => idHotel != null && excludedIds.some(id => sameId(id, idHotel)), [excludedIds])

    const toggle = useCallback(idHotel => {
        if (idHotel == null) return
        const next = excludedIds.some(id => sameId(id, idHotel))
            ? excludedIds.filter(id => !sameId(id, idHotel))
            : [...excludedIds, idHotel]
        updateSubmittedFilters({ excludedHotelID: next, cachedQuery })
    }, [excludedIds, updateSubmittedFilters, cachedQuery])

    // Ids without the given hotel: for the pin, a hotel becoming the main one is included again
    const withoutHotel = useCallback(idHotel => excludedIds.filter(id => !sameId(id, idHotel)), [excludedIds])

    return { excludedIds, isExcluded, toggle, withoutHotel }
}
